const fieldTitle: { [entityType: string]: { [fieldName: string]: string } } = {
  AccountStatus: {
    description: 'Description',
  },
  Address: {
    line1: 'Address Line 1',
    line2: 'Address Line 2',
    line3: 'Address Line 3',
    line4: 'Address Line 4',
    line5: 'Address Line 5',
    postCode: 'Post Code',
  },
  SalesBalance: {
    balance: 'Total Balance',
    month1: 'Month +1',
    month2: 'Month +2',
    month3: 'Month +3',
    month4: 'Month +4',
    current: 'Current',
    future: 'Future',
  },
  SalesInvoice: {
    documentNumber: 'Invoice No',
  },
  Country: {
    description: 'Country Name',
  },
  IsoCountry: {
    codeAlpha3: 'ISO Code',
  },
  IsoCurrency: {
    codeAlpha3: 'ISO Code',
  },
  VatBusinessCategory: {
    description: 'Description',
  },
  NominalBusinessCategory: {
    description: 'Description',
  },
  NominalCustomerAccountSet: {
    code: 'Code',
  },
  Nominal: {
    accountNo: 'Nominal Account No',
    name: 'Nominal Account Name',
  },
  SalesPaymentTerm: {
    description: 'Sales Payment Terms',
    paymentDate: 'Payment Due From Date',
    settlementDate: 'Settlement Days From Date',
    paymentDays: 'Payment Due Days',
    settlementDays: 'Settlement Due Days',
  },
  SalesReceipt: {
    documentAmount: 'Amount Received',
    documentNumber: 'Receipt No',
  },
  VatAuthority: {
    description: 'Name',
  },
  VatTransaction: {
    vatBusinessCategory: 'Business VAT Status',
    vatProductCategory: 'Product VAT Category',
  },
  VatRate: {
    vatBusinessCategory: 'Business VAT Status',
    vatProductCategory: 'Product VAT Category',
  },
  Warehouse: {
    description: 'Name',
  },
};

export default fieldTitle;
